import { BatteryFull } from 'lucide-react';

import type { Site } from '@/api/fe-api/domain/entities/site';
import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';

export type CardBatteryCellTypeProps = {
  site: Site;
  className?: string;
};

export function CardBatteryCellType({
  site,
  className,
}: CardBatteryCellTypeProps) {
  return (
    <StatsBox
      className={className}
      title="Battery Cell Type"
      value={site.cellType ?? '-'}
      icon={{ element: <BatteryFull /> }}
    />
  );
}
